import CRMConfigurationComp from 'component/crmConfig'
import React from 'react'

const CRMConfiguration = () => {
    return (
        <div>
            <CRMConfigurationComp />

        </div>
    )
}

export default CRMConfiguration